export enum PrincipalType {
    ServicePrincipal = "ServicePrincipal",
    Group = "Group",
    User = "User"
}